import React, { useState } from 'react';
import TruncateMarkup from 'react-truncate-markup';
export const AcTextTruncate = (props) => {
    const { text, maxLines = 1, maxWidth = 200, append, children } = props;
    const ellipsis = React.createElement("i", { className: "fal fa-ellipsis-h fa-fw" });
    const [isTruncate, setIsTruncate] = useState(false);
    return (React.createElement("div", { className: "d-flex pr-1", style: {
            width: maxWidth === '100%' ? maxWidth : `${maxWidth}px`,
        } },
        (!!children || !!text) && (React.createElement(TruncateMarkup, { lines: maxLines, onTruncate: (wasTruncated) => setIsTruncate(wasTruncated), ellipsis: React.createElement("span", { className: "position-relative", style: { zIndex: 1 } },
                ellipsis,
                append) },
            React.createElement("div", null, children || text))),
        !isTruncate && React.createElement("span", { className: "ml-auto mt-auto" }, append)));
};
AcTextTruncate.displayName = 'AcTextTruncate';
